<template>
	<div>
		<div>
			<div class="container1">
				<div class="title1">产品套餐</div>
				<div class="flex-row justify-between align-center">
					<div class="wow slideInLeft1 flex-row flex-center"><img src="@/assets/productPackage/self-support.png" alt="" /></div>
					<div class="wow slideInRight">
						<div class="subTitle">自营版</div>
						<div class="text text1">
							实现自营团队全面管理渠道终端目标客户资源、全链营销流向业绩数据、开发、拜访、学术会议、临床项目等全过程业务管理，以及营销效能统计和营销决策。
						</div>
						<el-button class="button-style" @click="openFree">免费试用</el-button>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="background">
				<div class="container2 flex-row justify-between align-center">
					<div class="wow slideInRight">
						<div class="subTitle">招商版</div>
						<div class="text text2">
							满足代理商转型为CSO服务商之后合约推广模式，从CSO准入审查服务签约、服务费用预算、服务计划到服务项目执行形成服务成果
							报告、到费用结算及发票与支付的全过程管理，通过药企委托CSO提供7大类88项不同的服务项目实现推广服务合规化管理。
						</div>
						<el-button class="button-style" @click="openFree">免费试用</el-button>
					</div>
					<div class="wow slideInLeft"><img src="@/assets/productPackage/attractInvestment.png" alt="" /></div>
				</div>
			</div>
		</div>

		<div>
			<div class="">
				<div class=" container3 flex-row justify-between align-center">
					<div class="wow slideInLeft">
						<div style="height: 462px; width: 483px;"><img src="@/assets/productPackage/instrument.png" alt="" /></div>
					</div>
					<div class="wow slideInRight">
						<div class="subTitle">医疗器械版</div>
						<div class="text text3">针对设备类、高值耗材类、IVD检验类行业特点，推广医疗器械专项维修与技术服务等服务管理。</div>
						<el-button class="button-style" @click="openFree">免费试用</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="bigBanner">
			<div class="title-name">企业营销与战略咨询</div>
			<div class="">
				<div class=" container flex-row justify-between ">
					<div class="wow slideInRight">
						<div class="text2">
							<div class="content flex-row" v-for="(item, index) in list" :key="item">
								<div class="contentDot"></div>
								<div class="contentText">{{ item }}</div>
							</div>
						</div>
						<el-button class="button-style" @click="toOpen">立即咨询</el-button>
					</div>
					<div class="wow slideInLeft"><div style="height: 300px; width: 200px;    "></div></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'demo2',
	data() {
		return {
			list: [
				'基于产品定位与营销模式策略规划',
				'基于病种设计诊疗一体化医患 服务方案',
				'新型医药营销推广模式与项目设计',
				'多渠道多模式推广架构下票税款财税筹划',
				'医药企业营销全环节合规组织、制度、文化 与体系规划'
			]
		};
	},
	methods: {
		toOpen() {
			this.$router.push('/freeTrial');
		},
		openFree() {
			this.$router.push('/freeTrial');
		}
	}
};
</script>

<style lang="scss" scoped>
.el-button {
	height: 44px !important;
}
.container {
	.slideInRight{
		margin-top: 190px;
	}
	width: 1200px;
	height: 730px;
	margin: 0 auto;
}
.bigBanner {
	width: 100% !important;
	height: 730px !important;
	background-image: url('../../../assets/productPackage/consultBanner.png');
	.content {
		height: 20px;
		align-items: center;
		margin-bottom: 19px;
		.contentDot {
			margin-right: 16px;
			width: 8px;
			height: 8px;
			border-radius: 4px;
			background: linear-gradient(270deg, #99baff 0%, #2970ec 100%);
		}
		.contentText {
			font-size: 16px;
			font-weight: 400;
			color: #666666;
			line-height: 20px;
		}
	}
	// background-repeat: no-repeat;
}
.subTitle {
	font-size: 28px;
	font-weight: 600;
	color: #000000;
	line-height: 40px;
}
.text {
	margin-top: 20px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
	line-height: 26px;
}
.container1 {
	width: 1200px;
	height: 772px;
	margin: 0 auto;
	margin-top: 105px;
	.title1 {
		font-size: $global-font-size-32;
		color: $global-default-black-color;
		text-align: center;
		font-weight: 600;
		margin-bottom: 99px;
	}
	.slideInLeft1 {
		height: 528px;
		width: 463px;
	}
	.text1 {
		width: 512px;
	}
}
.background {
	background: $global-default-opacity-background;
}
.container2 {
	width: 1200px;
	height: 592px;
	margin: 0 auto;
	position: relative;
	.text2 {
		width: 469px;
	}
	.slideInLeft {
		height: 537px;
		width: 589px;
		position: absolute;
		bottom: -28px;
		right: 0;
	}
}
.container3 {
	width: 1200px;
	height: 672px;
	margin: 0 auto;
	.text3 {
		width: 494px;
	}
}

.title-name {
	font-size: $global-font-size-32;
	color: $global-default-black-color;
	padding-top: 99px;
	text-align: center;
	font-weight: 600;
}

// .text1 {
// 	font-size: 28px;
// 	// font-weight: 600;
// 	color: #000000;
// 	line-height: 40px;
// }

// .text2 {
// 	margin-top: 20px;
// 	font-size: 16px;
// 	font-weight: 400;
// 	color: #666666;
// 	line-height: 24px;
// }

.button-style {
	margin-top: 20px;
	width: 199px;
	height: 49px;
}
</style>
